import { Routes } from '@angular/router';
import { TabsPage } from './pages/tabs/tabs.page';
import { AuthGuard } from './services/auth.guard';
// ❌ Ya no usamos exploreAccessGuard en las tabs
// import { exploreAccessGuard } from './guards/explore-access.guard';

export const routes: Routes = [
  // 🔹 Ruta por defecto → Today
  {
    path: '',
    redirectTo: 'tabs/today',
    pathMatch: 'full',
  },

  // 🔹 Login (fuera de las tabs)
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },

  // 🔹 Pantalla de cuenta bloqueada (SIN AuthGuard para evitar bucles)
  {
    path: 'banned',
    loadComponent: () =>
      import('./pages/banned/banned.page').then((m) => m.BannedPage),
  },

  // 🔹 📍 Elegir ubicación (antes: onboarding)
  // 👉 Mantén esta pantalla accesible desde Settings, pero NO se fuerza en el primer login.
  {
    path: 'choose-location',
    loadComponent: () =>
      import('./pages/location-onboarding/location-onboarding.page').then(
        (m) => m.LocationOnboardingPage
      ),
    canActivate: [AuthGuard],
  },

  // 🔹 Alias legacy para no romper navegación antigua
  {
    path: 'location-onboarding',
    redirectTo: 'choose-location',
    pathMatch: 'full',
  },

  // 🔹 Participación en reto
  {
    path: 'challenge-participation',
    loadComponent: () =>
      import(
        './pages/challenge-participation/challenge-participation.page'
      ).then((m) => m.ChallengeParticipationPage),
    canActivate: [AuthGuard],
  },

  // 🔹 ⚡ Celebración (full screen)
  {
    path: 'celebration',
    loadComponent: () =>
      import('./pages/celebration/celebration.page').then(
        (m) => m.CelebrationPage
      ),
  },

  // 🔹 Elección de camino
  {
    path: 'choose-path',
    loadComponent: () =>
      import('./pages/choose-path/choose-path.page').then(
        (m) => m.ChoosePathPage
      ),
    canActivate: [AuthGuard],
  },

  // 🔹 Cierre de temporada / MVP
  {
    path: 'season-complete',
    loadComponent: () =>
      import('./pages/season-complete/season-complete.page').then(
        (m) => m.SeasonCompletePage
      ),
    canActivate: [AuthGuard],
  },

  // 🔹 Explore bloqueado
  {
    path: 'locked-explore',
    loadComponent: () =>
      import('./pages/locked-explore/locked-explore.page').then(
        (m) => m.LockedExplorePage
      ),
    canActivate: [AuthGuard],
  },

  // 🔹 🛡️ ADMIN PANEL
  {
    path: 'admin',
    loadComponent: () =>
      import('./pages/admin/admin.page').then((m) => m.AdminPage),
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/denied',
    loadComponent: () =>
      import('./pages/admin/denied.page').then((m) => m.DeniegPage),
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/reports',
    loadComponent: () =>
      import('./pages/admin/admin-reports.page').then(
        (m) => m.AdminReportsPage
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/users',
    loadComponent: () =>
      import('./pages/admin/admin-users.page').then(
        (m) => m.AdminUsersPage
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/challenges',
    loadComponent: () =>
      import('./pages/admin/admin-challenges.page').then(
        (m) => m.AdminChallengesPage
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/settings',
    loadComponent: () =>
      import('./pages/admin/admin-settings.page').then(
        (m) => m.AdminSettingsPage
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/analytics',
    loadComponent: () =>
      import('./pages/admin/admin-analytics.page').then(
        (m) => m.AdminAnalyticsPage
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/users/:uid',
    loadComponent: () =>
      import('./pages/admin/admin-user-detail.page').then(
        (m) => m.AdminUserDetailPage
      ),
    canActivate: [AuthGuard],
  },

  // 🔹 Tabs principales (barra inferior)
  {
    path: 'tabs',
    component: TabsPage,
    children: [
      // TODAY
      {
        path: 'today',
        loadComponent: () =>
          import('./pages/today/today.page').then((m) => m.TodayPage),
        canActivate: [AuthGuard],
      },

      // FEED por día
      {
        path: 'feed/:day',
        loadComponent: () =>
          import('./pages/feed/feed.page').then((m) => m.FeedPage),
        canActivate: [AuthGuard],
      },

      // EXPLORE paramétrico
      {
        path: 'explore/:day',
        loadComponent: () =>
          import('./pages/explore/explore.page').then((m) => m.ExplorePage),
        canActivate: [AuthGuard],
      },

      // EXPLORE normal
      {
        path: 'explore',
        loadComponent: () =>
          import('./pages/explore/explore.page').then((m) => m.ExplorePage),
        canActivate: [AuthGuard],
      },

      // 🌍 GLOBAL — laboratorio admin
      {
        path: 'global',
        loadComponent: () =>
          import('./pages/global/global.page').then(
            (m) => m.GlobalPage
          ),
        canActivate: [AuthGuard],
      },

      // PROFILE
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/profile/profile.page').then((m) => m.ProfilePage),
        canActivate: [AuthGuard],
      },

      // SEGUIDOS
      {
        path: 'following',
        loadComponent: () =>
          import('./pages/following/following.page').then(
            (m) => m.FollowingPage
          ),
        canActivate: [AuthGuard],
      },

      // PERFIL PÚBLICO
      {
        path: 'user/:uid',
        loadComponent: () =>
          import('./pages/public-profile/public-profile.page').then(
            (m) => m.PublicProfilePage
          ),
        canActivate: [AuthGuard],
      },

      // redirect por defecto dentro de tabs
      {
        path: '',
        redirectTo: 'today',
        pathMatch: 'full',
      },
    ],
  },

  // 🔹 Catch-all
  { path: '**', redirectTo: 'tabs/today' },
];
